module.exports = {
  UserDefinedField1: 'User Defined Field1',
  UserDefinedField2: 'User Defined Field2',
  UserDefinedField3: 'User Defined Field3',
  UserDefinedField4: 'User Defined Field4',
  query: 'Query',
  viewDetails: 'View Details',
  collectInvoice: 'Collect invoice',
  print: 'Print',
  newPaymentRequest: 'New Payment Request',
  deletePaymentRequest: 'Delete Payment Request',
  submintPaymentRequest: 'SUBMIT Payment Request',
  submit: 'Submit',
  delete: 'Delete',
  businessApproval: 'Business approval',
  officeApproval: 'Office approval',
  departmentApproval: 'Department approval',
  financialApproval: 'Financial approval',
  return: 'Return',
  financialAudit: 'Financial Audit',
  applicationStatus: 'Application status',
  notSubmitted: 'Not submitted',
  awaitBusinessApproval: 'Await Business approval',
  awaitFinancialApproval: 'Await Financial approval',
  NosubmitWeaver: 'Nosubmit Weaver',
  WeaverApproving: 'Weaver Approving',
  WeaverApproved: 'Weaver Approved',
  approval: 'Approval',
  unpaid: 'Unpaid',
  all: 'All',
  inquiryWay: 'Inquiry way',
  accordingToCharge: 'According to charge',
  accordingToBusiness: 'According to business',
  includeReceivables: 'Include receivables',
  removeCharge: 'Remove charge',
  addCharge: 'Add charge',
  back: 'Back',
  next: 'Next',
  save: 'Save',
  cancel: 'Cancel',
  saveAndAdd: 'Save and Add',
  chargeRemark: 'Charge Remark',
  containerNo: 'ContainerNo',
  destinationAgent: 'Destination Agent',
  receivablesWriteOfStatus: 'Receivables Write Of Status',
  businessNumber: 'Business number',
  consignationCompany: 'Consignation company',
  settlementAgent: 'Settlement agent',
  mbl: 'MBL',
  importhbl: 'IMPORT HBL',
  vessel: 'Vessel',
  voyage: 'Voyage',
  billNo: 'Bill No',
  inputBy: 'Input By',
  accountStatementNo: 'Account statement No',
  invoiceNo: 'Invoice No',
  lackInvoiceFlag: 'Lack invoice',
  uploadAttachmentFlag: 'Has attachment',
  itemNo: 'Project number',
  businessType: 'Business type',
  solicitationType: 'Business type',
  amountRange: 'Amount range',
  chargeItem: 'Charge item',
  businessDate: 'Business date',
  etd: 'ETD',
  eta: 'ETA',
  atd: 'ATD',
  ata: 'ATA',
  currency: 'Currency',
  operation: 'Operation',
  sales: 'Sales',
  advanceMoneyOrNot: 'Advance money or not',
  adjustedOrNot: 'Adjusted or not',
  wroteOffOrNot: 'Wrote off or not',
  generatedBillsOrNot: 'Generated bills or not',
  invoicedOrNot: 'Invoiced or not',
  appliedForPaymentOrNot: 'Applied for payment or not',
  lclMasterOrNot: 'LCL master or not',
  masterFlagOrNot: 'Master Flag or not',
  department: 'Department',
  contactPerson: 'Contact person',
  settlementType: 'Settlement type',
  invoicingMethod: 'Invoicing method',
  accrued: 'Accrued',
  businessReferenceNumber: 'Business reference number',
  SONO: 'SONO',
  warehouseNo: 'Warehouse No',
  bookingNo: 'Booking No',
  auditor: 'Auditor',
  settlementCompany: 'Settlement company',
  businessStatus: 'Business status',
  feeStatus: 'Fee status',
  confirmationStatus: 'Confirmation status',
  settleAccountsTo: 'Settle accounts to',
  customerChineseName: 'Chinese name of the commissioning unit',
  vesselAndVoyage: 'Vessel/Voyage',
  portOfLoading: 'Port of Loading',
  portOfDestination: 'Port of destination',
  customerService: 'Customer service',
  financialDate: 'Financial date',
  domesticInternational: 'Domestic/International',
  paymentType: 'Payment type',
  invoiceNumber: 'Invoice Number',
  // Daily payment request: department of the fund (display text)
  enterpriseWechatDepartment: 'Payment Department',
  enterpriseWechatCompany: 'Paying Company',
  oneEnterpriseWechatCompany: 'Paying Company',
  enterpriseWechatBelongCompany: 'Belong Company',
  enterpriseWechatType2Company: 'Paying Company',
  enterpriseWechatType2Department: 'Payment Department',
  enterpriseWechatType1OfficeCity: 'Office Address',
  enterpriseWechatType4OfficeCity: 'Office City',
  enterpriseWechatType4Company: 'Paying Company',
  enterpriseWechatType4PayMethod: 'Payment Method',
  enterpriseWechatPayMethod: 'Payment Method',
  enterpriseWechatFeeType: 'Payment/Fee Type',
  enterpriseWechatWaterNotifier: 'Remittance Notifier',
  // Titles for matching Enterprise Wechat template fields; can differ from display text
  // 暂时与中文模板保持一致，后续若有英文模板再调整
  enterpriseWechatDepartmentMatch: '款项所属部门',
  enterpriseWechatCompanyMatch: '付款公司',
  oneEnterpriseWechatCompanyMatch: '所属公司：',
  enterpriseWechatBelongCompanyMatch: '所属公司',
  enterpriseWechatType2CompanyMatch: '付款公司',
  enterpriseWechatType2DepartmentMatch: '费用所属部门',
  enterpriseWechatType1OfficeCityMatch: '办公地点',
  enterpriseWechatType4OfficeCityMatch: '办公城市',
  enterpriseWechatType4CompanyMatch: '付款公司',
  enterpriseWechatType4PayMethodMatch: '付款方式',
  enterpriseWechatPayMethodMatch: '付款方式',
  enterpriseWechatFeeTypeMatch: '付款/费用类型',
  enterpriseWechatWaterNotifierMatch: '水单通知人',
  // Special payment request: charge ownership department
  enterpriseWechatSpecialDepartment: 'Charge Department',
  enterpriseWechatSpecialDepartmentMatch: '费用所属部门：',
  // Located department (shared by all payment types)
  enterpriseWechatLocatedDepartment: 'Department',
  enterpriseWechatLocatedDepartmentMatch: '所在部门',
  enterpriseWechatFieldRequired: '{0} is required',
  enterpriseWechatWaterNotifierMissing: 'The user has not bound an Enterprise WeChat contact. Please contact the administrator.',
  unit: 'Unit',
  quantity: 'Quantity',
  unitPrice: 'Unit-Price',
  taxIncludedPrice: 'Tax included price',
  taxExcludedPrice: 'Tax excluded price',
  taxRate: 'Tax rate',
  taxAmount: 'Tax amount',
  theAmountOfWriteOffs: 'The amount of write offs',
  currencyAmountOfWriteOffs: 'Write off amount by currency total',
  amountNotWrittenOff: 'Outstanding Balance',
  creator: 'Creator',
  dateOfCreation: 'Date of Creation',
  customer: 'Customer',
  carrier: 'Carrier',
  applicationNo: 'Application No',
  status: 'Status',
  bySettlementAgent: 'By settlement agent',
  oceanExport: 'Ocean export',
  oceanImport: 'Ocean import',
  airExport: 'Air export',
  airImport: 'Air import',
  exchangeRate: 'Exchange rate',
  amount: 'Amount',
  paymentPeriod: 'Payment period',
  paymentPeriodUnit: 'Payment period unit',
  methodOfPayment: 'Method of payment',
  applicant: 'Applicant',
  dateOfApplication: 'Date of application',
  remarks: 'Remarks',
  replaceInvoiceRemark: 'Replacement invoice remark',
  purpose: 'Purpose',
  postscript: 'Postscript',
  preRemarks: 'Notes on Advance Payment',
  ticketNo: 'Bill no',
  workflowNo: 'WorkflowNo',
  total: 'Total',
  controlledOrNot: 'Controlled or not',
  uncheck: 'Uncheck',
  newActualReceipt: 'New actual receipt',
  newActualPayment: 'New actual payment',
  edit: 'Edit',
  invalid: 'Invalid',
  viewWriteOffList: 'View write off list',
  receiptDate: 'Receipt date',
  paymentDate: 'Payment date',
  receipt: 'Receipt',
  payment: 'Payment',
  new: 'New',
  edit2: 'edit',
  containerSizeAmount: 'Container size/amount',
  writeOffCurrency: 'Write off currency',
  writeOffExchangeRate: 'Write off Exchange rate',
  chargeOriginalCurrency: 'Charge original currency',
  chargeOriginalAmount: 'Charge original amount',
  chargeOriginalExchangeRate: 'Charge original exchange rate',
  monetaryEquivalent: 'Monetary equivalent',
  originalAmount: 'original amount',
  receivables: 'Receivables',
  payables: 'Payables',
  totalWriteOffs: 'Total write offs',
  cancelPartialWriteOff: 'Cancel partial write off',
  exportExcel: 'Export excel',
  exportPDF: 'Export PDF',
  writeOffList: 'Write off list',
  isReceivable: 'Receivable',
  customJobType: 'Custom Job Type',
  HBL: 'HBL',
  export: 'Export',
  import: 'Import',
  invoiceHeader: 'Invoice header',
  sellerInvoiceTitle: 'Seller invoice title',
  separateNumber: 'Separate Number',
  modifyTime: 'Update Payment Time',
  modifiedBy: 'Update Payment Person',
  relatedJob: 'Related Job',
  trustFromJob: 'TrustFrom Job',
  carrierId: 'Carrier Id',
  confirmDate: 'Confirmation Date',
  confirmUser: 'Confirmation User',
  planer: 'Planner',
  customerContact: 'Customer Contact',
  isNeedInvoice: 'Invoice Need',
  confirmRemarks: 'Confirm Remarks',
  needInvoice: 'Invoice Need',
  invoiceDate: 'Invoice Date',
  invoiceDateAll: 'Invoice Date',
  invoiceState: 'Invoice State',
  writeOffDate: 'write Off Date',
  totalCurrency: 'Currency Amount',
  billPaymentNo: 'Payment application number',
  bankOfDeposit: 'Bank Of Deposit',
  bankAccount: 'Bank Account',
  changePaymentRequest: 'Change Payment Request',
  processPaymentRequest: 'Process',
  couldNotSearhWriteOffJobFromThisWindow: 'Tip:Could Not Searh WriteOff Job Or Charge From This Window',
  writeOffSerialNumber: 'writeOffSerialNumber',
  payReceiveDate: 'PayReceiveDate',
  portOfDestinationAirport: 'Port Of Destination Airport',
  portOfDestinationSeaport: 'Port Of Destination Seaport',
  portOfDischargeSeaport: 'Port Of Discharge Seaport',
  portOfLoadingAirport: 'Port Of Loading Airport',
  portOfLoadingSeaport: 'Port Of Loading Seaport',
  portOfTransfer: 'Port Of Transfer',
  businessCreateDate: 'Business Create Date',
  approveHistoryNode: 'Payment Approve Node',
  invoice_voucherDate: 'Voucher Date2',
  time: 'Time',
  approveTime: 'Approve Time',
  operator: 'Operator',
  approval_results: 'Approval Results',
  applicationDepartment: 'Application Department',
  settleDepartmentPrefix: 'Clearing Department',
  writeOffStatus: 'Write off status',
  moneyWriteOffStatus: 'Charge write off status',
  sendWeaver: 'Send Cloud Platform Audit',
  receivablesAndPayables: 'Receivables And Payables',
  operationDate: 'Operation Date',
  newPaymentRequest_SR: 'Payment Request',
  deletePaymentRequest_SR: 'Delete',
  sendWeaver_SR: 'Send to Cloud platform',
  viewDetails_SR: 'View Details',
  lastInvoicingDate: 'Last Invoicing Date',
  paymentRequestState: 'Payment Request State',
  Cargo_ApplicantPassTips: 'Do you agree with this payment application？',
  Cargo_ApplicantReturnToSubmitterTips: 'This application will be returned to the submitter, are you sure to return it?',
  Cargo_ApplicantReturnToBusinessTips: 'This application will be returned to the business approver, are you sure to return it?',
  Cargo_ApplicantReturnToFinancialTips: 'This application will be returned to the financial approver, are you sure to return it?',
  Cargo_ApplicantReturnTips: 'This application will be returned to the submitter, are you sure to return it?',
  approveReason: 'Please enter the reason for consent',
  returnReason: 'Please enter the return reason',
  bdApproveState: 'Business approval status',
  ccApproveState: 'Financial approval status',
  finApproveState: 'Final approval status',
  receiptPaymentNo: 'Receipt and payment voucher number',
  // REQ-0040 WeChat Work approval route tips when submitting a special expense application (see specialFeeApprovalRoute.js)
  specialFeeExpenseApprovalRouteTip: 'The special expense application amount is less than 50,000. The "Expense Reimbursement Application" approval will be initiated in WeCom.',
  specialFeeSpecialApprovalRouteTip: 'The special expense application amount is greater than 50,000. The "Special Expense Application" approval will be initiated in WeCom.',
  specialFeeSpecialApprovalRouteTipKh: 'The "Special Expense Application" approval will be initiated in WeCom.',
  confirmSubmitTip: 'Confirm submission?'
}
